<template>
  <v-dialog v-model="dialog" max-width="600" scrollable>
    <v-card v-if="producto" class="pa-4">
      <v-card-title class="font-weight-bold" style="font-size: 18px; display: flex; justify-content: space-between; align-items: center;">
        Detalle del Producto
        <v-btn icon small @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row>
          <!-- IMAGEN -->
          <v-col cols="12" class="d-flex justify-center">
            <div style="width: 100%; max-width: 350px; overflow: hidden; border-radius: 8px; background: #f5f5f5;">
              <img
                :src="serverUrl + 'api/productos/get_img_unico_producto/' + producto.id + '/' + producto.link_photo"
                style="width: 100%; height: 250px; object-fit: contain;"
              />
            </div>
          </v-col>

          <!-- DATOS -->
          <v-col cols="12">
            <div class="mb-2" style="font-size: 18px; font-weight: 700;">
              {{ producto.descripcion }}
            </div>

            <div v-if="producto.sub1" class="mb-1" style="font-size: 14px; color: #555;">
              {{ producto.sub1 }}
            </div>

            <div v-if="producto.sub2" class="mb-1" style="font-size: 13px; color: #777;">
              {{ producto.sub2 }}
            </div>

            <div class="mb-2 mt-3" style="font-size: 20px; font-weight: 700; color: #8B0000;">
              Gs. {{ formatearPrecio(producto.pvu) }}
            </div>

            <div class="mb-1" style="font-size: 13px;">
              <span class="font-weight-bold">Stock disponible:</span> {{ producto.cantidad_total }}
            </div>

            <div v-if="producto.modelo" class="mb-1" style="font-size: 13px;">
              <span class="font-weight-bold">Modelo:</span> {{ producto.modelo }}
            </div>

            <div v-if="producto.categoria" class="mb-1" style="font-size: 13px;">
              <span class="font-weight-bold">Categoría:</span> {{ producto.categoria.descripcion }}
            </div>

            <div v-if="producto.info" class="mt-3">
              <v-divider class="mb-2"></v-divider>
              <div class="font-weight-bold mb-1" style="font-size: 13px; color: #78909C;">Información Detallada</div>
              <div style="font-size: 13px; color: #444; white-space: pre-line;">{{ producto.info }}</div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { http } from '@/services/config';

export default {
  name: 'ProductoPedidoDialog',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    producto: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      serverUrl: http.defaults.baseURL
    };
  },

  computed: {
    dialog: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); }
    }
  },

  methods: {
    formatearPrecio(valor) {
      if (!valor) return '0';
      return Math.floor(valor).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }
};
</script>
